import Service from "../Service";

const resource = "FrzLinesTransferHistory/";

export default {
    list(filter, requestID) {
        return Service.post(resource + "list", filter, {
            params: { requestID: requestID },
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
    save(obj, requestID) {
        const endpoint = (obj.LthID && obj.LthID > 0) ? "update" : "save";
        return Service.post(resource + endpoint, obj, {
            params: { requestID: requestID },
        });
    },
    execute(obj, requestID) {
        return Service.post(resource + "execute", obj, {
            params: { requestID: requestID },
        });
    },
    delete(obj, requestID) {
        return Service.post(resource + "delete", obj, {
            params: { requestID: requestID },
        });
    },
}
